import { BaseSchema, BlazeTableSchema } from '@blaze-shared/schema-domain';
import { Connection, DeleteWorkflowNode, Workflow } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WORKFLOW_SCHEMA_KEY,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('Delete')
export class DeleteNodeSchemaProvider extends SchemaProvider<DeleteWorkflowNode> {
  override getSchemas(
    workflow: Workflow,
    node: DeleteWorkflowNode,
    schemas: {
      input: Map<string | symbol, BaseSchema>;
      output: Map<string | symbol, BaseSchema>;
      allSchemas: Record<string, BaseSchema>;
      userSchema?: BlazeTableSchema | null;
      accountSchema?: BlazeTableSchema | null;
    },
    connections: Connection[],
  ): Map<string | symbol, BaseSchema> {
    const nodeSchemas = super.getSchemas(workflow, node, schemas, connections);

    if (node.datasetId) {
      nodeSchemas.set(WORKFLOW_SCHEMA_KEY, schemas.allSchemas[node.datasetId]);
    }

    return nodeSchemas;
  }
}
